import styled from "@emotion/styled";

import { LiveArticleContentItem } from "./item";

export const Container = styled.div``;

export const StyledLiveArticleContentItem = styled(LiveArticleContentItem)`
  margin-block-end: 32px;
`;
